import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { AuthService } from '@auth/services/auth.service';

@Injectable({
    providedIn: 'root'
})
export class AuthGuard implements CanActivate {
    constructor(private readonly auth: AuthService, private readonly router: Router) { }

    canActivate(): boolean | UrlTree {
        if (!this.auth.restoreSession()) {
          return this.router.createUrlTree(['/login']);
        }
        return this.auth.isAdmin()
          ? true
          : this.router.createUrlTree(['/login']);
    }
}
